import { Box } from '@mui/material'
import { hasUserRight } from '@src/contexts/AppContext'
import useFeatureFlags from '@src/data/api/featureSwitch-api/featureSwitch-api'
import { EUserRights } from '@src/data/types/Constants'
import MerchantsListReport from './MerchantsListReport'
import MerchDbAccessReport from './MerchDbAccessReport'

const Reports = () => {
  const [featureFlags] = useFeatureFlags()

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {<MerchantsListReport />}
      {featureFlags?.enableMerchDbUserStatsReport && hasUserRight(EUserRights.canDownloadMerchDbAccessReport) && (
        <MerchDbAccessReport />
      )}
    </Box>
  )
}

export default Reports
